import commonAxios from "@/utils/axios/common.axios";

import type { AxiosResponseData } from "@/utils/axios";
import { IGetPageStructuresPayload } from "./pageStructures.api.type";

const pageStructuresApi = {
  getPageStructures: (payload: IGetPageStructuresPayload) => {
    return commonAxios.get<AxiosResponseData>(
      "/pageStructures/getListByPage.json",
      {
        params: payload.params,
        headers: payload.headers,
        cancelToken: payload.cancelToken,
      }
    );
  },
};

export default pageStructuresApi;
